import { routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { applyMiddleware, compose, createStore as createStoreRedux } from 'redux';
import thunk from 'redux-thunk';
import reducers from '../reducers';

declare const window: any;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default function createStore(history: History) {
  const middlewares = applyMiddleware(routerMiddleware(history), thunk);
  return createStoreRedux(reducers(history), composeEnhancers(middlewares));
}
